import { useState } from "react";
import { Alert, Tab, Tabs } from "@mui/material";
import { grants } from "../../../backoffice.access_control";
import { PageTitle } from "../../../misc/PageTitle";
import { Column } from "../../../misc/Column";
import { AccessDenied } from "../../../misc/AccessDenied";
import { useAutovioContext } from "../../../hooks/useAutovioContext";
import { DATEVSettings } from "./DATEVSettings";
import { DATEVExportRuns } from "./DATEVExportRuns";

export function DrivingSchoolDATEV() {
  const [{ drivingSchoolId }] = useAutovioContext();
  const [tab, setTab] = useState("exports");
  if (!grants.has("viewDATEV") && !grants.has("editDATEVConfig")) return <AccessDenied />;
  return (
    <Column>
      <PageTitle>DATEV</PageTitle>
      {!drivingSchoolId ? (
        <Alert severity="info">Bitte wähle eine Fahrschule aus.</Alert>
      ) : (
        <>
          <Tabs value={tab} onChange={(_, value) => setTab(value)}>
            <Tab value="exports" label="Exportdateien" />
            <Tab value="settings" label="Einstellungen" />
          </Tabs>
          {tab === "settings" ? <DATEVSettings key={drivingSchoolId} /> : <DATEVExportRuns key={drivingSchoolId} />}
        </>
      )}
    </Column>
  );
}
